import {
  Badge,
  MantineColor,
  useMantineColorScheme,
  useMantineTheme,
} from '@mantine/core';
import {
  IconBrandAndroid,
  IconBrandApple,
  IconBrandAppstore,
  IconBrandFinder,
  IconBrandUbuntu,
  IconBrandWindows,
  IconCloudDataConnectionFilled,
  IconDevices,
  IconEyeBolt,
  IconHomeLink,
  IconPlugConnected,
  IconTag,
  IconUserFilled,
  IconWifi,
  IconX,
} from '@tabler/icons-react';

interface Props {
  tag: string;
  removeable?: boolean;
  onRemove?: () => void;
}

export const Tag = ({ tag, removeable, onRemove }: Props) => {
  const theme = useMantineTheme();
  let icon = <IconTag size={12} />;
  // TODO: Add icons for all tags
  switch (tag) {
    case 'critical':
    case 'important':
    case 'normal':
      icon = <IconEyeBolt size={12} />;
      break;
    case 'wifi':
      icon = <IconWifi size={12} />;
      break;
    case 'ethernet':
      icon = <IconPlugConnected size={12} />;
      break;
    case 'laptop':
    case 'audio':
    case 'camera':
    case 'gameconsole':
    case 'pc':
    case 'phone':
    case 'printer':
    case 'securityalarm':
    case 'tablet':
    case 'tv':
    case 'other':
      icon = <IconDevices size={12} />;
      break;
    case 'nas':
      icon = <IconDevices size={12} />;
      break;
    case 'android':
      icon = <IconBrandAndroid size={12} />;
      break;
    case 'ios':
      icon = <IconBrandAppstore size={12} />;
      break;
    case 'linux':
      icon = <IconBrandUbuntu size={12} />;
      break;
    case 'macos':
      icon = <IconBrandApple size={12} />;
      break;
    case 'windows':
      icon = <IconBrandWindows size={12} />;
      break;
    case 'esp':
    case 'unknown':
      icon = <IconBrandFinder size={12} />;
      break;
    case 'admin':
    case 'regular':
    case 'child':
      icon = <IconUserFilled size={12} />;
      break;
    case 'iot':
      icon = <IconHomeLink size={12} />;
      break;
    default:
      icon = <IconTag size={12} />;
      break;
  }
  if (removeable && onRemove) {
    return (
      <Badge
        size="sm"
        variant="gradient"
        leftSection={icon}
        rightSection={
          <IconX 
            size={12} 
            style={{ cursor: 'pointer' }} 
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
          />
        }
        gradient={{ to: theme.colors.ducky[4], from: theme.colors.tealish[3] }}
      >
        {tag}
      </Badge>
    );
  }

  return (
    <Badge
      size="sm"
      variant="gradient"
      leftSection={icon}
      gradient={{ to: theme.colors.ducky[4], from: theme.colors.tealish[3] }}
    >
      {tag}
    </Badge>
  );
};
